import { FC, useCallback } from 'react';
import { nameof } from '../../utils/stringUtils';
import { CustomWidthSpinButton } from '../../shared/styled-components';

function roundTo2Decimals(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

function correctPercentage(value: number): number {
  if (value < 0)
    return 0;
  if (value > 1)
    return 1;

  return roundTo2Decimals(value);
}

interface IProps {
  value: number;
  onChange(value: number): void;
  id?: string;
  label?: string;
  disabled?: boolean;
  width?: string | number;
}

const PercentageSpinButton: FC<IProps> = ({ value, onChange, id, label, disabled, width }) => {
  const updateValue = useCallback(
    (_: unknown, val: string | undefined) => {
      const numericPart = val?.match(/(\d+) ?%?/)?.[1];

      const result = numericPart
        ? Number.parseInt(numericPart) / 100
        : 0;

      onChange(correctPercentage(result));
    },
    [onChange],
  );

  return (
    <CustomWidthSpinButton id={id}
      label={label}
      disabled={disabled}
      value={`${roundTo2Decimals((value ?? 0) * 100)}%`}
      onChange={updateValue}
      inputProps={{ onKeyDown: (e) => { if (e.key === 'Enter') updateValue(undefined, (e.target as EventTarget & HTMLInputElement).value); } }}
      onBlur={(e) => updateValue(undefined, e.target.value)}
      min={0} max={1}
      onIncrement={() => onChange(correctPercentage(value + 0.01))}
      onDecrement={() => onChange(correctPercentage(value - 0.01))}
      styles={{ root: { width } }}
    />
  );
};

PercentageSpinButton.displayName = nameof({ PercentageSpinButton });
export default PercentageSpinButton;